import React from "react";
import styled, { keyframes } from "styled-components";
import { FaSpinner } from "react-icons/fa";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  visibility: ${({ $saving }) => ($saving ? "hidden" : "visible")};
`;

const Spinner = styled.span`
  position: absolute;
  inset: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const Spinning = styled(FaSpinner)`
  animation: ${spin} 0.8s linear infinite;
`;

export default function SaveButton({
  saving,
  disabled,
  onClick,
  children = "Save",
  type = "button",
  className,
  style,
  title,
}) {
  return (
    <Button
      type={type}
      className={className}
      style={style}
      title={title}
      onClick={onClick}
      disabled={disabled}
      aria-busy={saving ? "true" : undefined}
    >
      <Label $saving={saving}>{children}</Label>
      {saving ? (
        <Spinner>
          <Spinning size={14} />
        </Spinner>
      ) : null}
    </Button>
  );
}
